
import { unAuthorized } from '../helpers/common'
const axios = require('axios')

class FeatureService {
  async getFeatures (filter, token) {
    try {
      let features = []
      // if running on local, use the mock data
      if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
        await new Promise(resolve => setTimeout(resolve, 500))
        const { data } = require('../mocks/features.json')
        features = data
      } else {
        const lambdaUrl = `${process.env.VUE_APP_API_URL}/feature/getAll`
        // console.log('lambdaUrl', lambdaUrl)

        const { data } = await axios.get(lambdaUrl, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })

        features = data.data
      }

      if (filter && filter.connector) {
        return (filter.connector === 'all') ? { data: features } : { data: features.filter(feature => feature.connectors.includes(filter.connector)) }
      } else {
        return { data: this.features }
      }
    } catch (error) {
      console.log('Error:', error)
      if (error.response?.status === 401) {
        unAuthorized()
      }
    }
  }

  async getFeature (id, token) {
    try {
      let feature = {}
      // if running on local, use the mock data
      if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
        await new Promise(resolve => setTimeout(resolve, 500))
        const { data } = require('../mocks/features.json')
        feature = data.find(feature => feature.id === id)
      } else {
        const lambdaUrl = `${process.env.VUE_APP_API_URL}/feature/getByFilter?id=${id}`
        // console.log('lambdaUrl', lambdaUrl)

        const { data } = await axios.get(lambdaUrl, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        feature = data.data
      }
      return { data: feature }
    } catch (error) {
      console.log('Error:', error)
      if (error.response?.status === 401) {
        unAuthorized()
      }
    }
  }
}

export default new FeatureService()
